import React from "react";
import { makeStyles } from "@material-ui/core";
import Header from "../../components/Header";
import Appbar from "../../components/Appbar";
import Parceiros from "../../components/Parceiros";
import PostagensTabs from "../../components/PostagensTabs";
import TabsNavigation from "../../components/TabsNavigation";
import Footer from "../../components/Footer";
import ParceirosF from "../../components/ParceirosF";
import { useTabs } from "../../hooks/useTabs";

export default function Main() {
  const classes = useStyles();
  const {
    activeTab,
    switchTab,
    getTabState,
    updateTabState,
    setTabLoading,
    setTabPosts,
  } = useTabs();

  const getApiEndpoint = (tabName) => {
    return tabName === 'instagram' ? '/instagram/timeline' : '/timeline';
  };

  return (
    <div className={classes.root}>
      <Header />
      <div
        style={{
          top: 0,
          position: "sticky",
          zIndex: "1000",
        }}
      >
        <Appbar />
      </div>
      <div className={classes.content}>
        <div className={classes.limit}>
          <div className={classes.postsContainer}>
            <TabsNavigation
              activeTab={activeTab}
              onTabChange={switchTab}
            />
            <PostagensTabs
              tabName={activeTab}
              apiEndpoint={getApiEndpoint(activeTab)}
              tabState={getTabState(activeTab)}
              onUpdateTabState={updateTabState}
              onSetTabLoading={setTabLoading}
              onSetTabPosts={setTabPosts}
            />
          </div>
          <div
            style={{
              top: "4rem",
              position: "sticky",
            }}
          >
            <Parceiros />
          </div>
        </div>
      </div>
      <div className={classes.mobile}>
        <ParceirosF />
      </div>
      <Footer />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexDirection: "column",
    backgroundColor: theme.colors.white,
    minHeight: "100vh",
    width: "100vw",
    display: "flex",
  },
  content: {
    flex: 1,
    justifyContent: "center",
    display: "flex",
  },
  limit: {
    width: "100%",
    maxWidth: "1366px",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "row",
    display: "flex",
  },
  mobile: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    position: "sticky",
    bottom: "56px",
  },
  stick: {
    top: 0,
    position: "sticky",
  },
  postsContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
}));
